import useEditDoctor from "./hooks/useEditDoctor"
import PersonalInfo from "./sections/PersonalInfo"
import SpecialitiesDocs from "./sections/SpecialitiesDocs"
import { Block } from "@/components/crRender"
import useForm from "@/hooks/useForm"
import { ActionBtn } from "@/components/Exporter"

const EditedInfo = ({ data, isLoading }) => {

    const { formHandler, handleProfileImageChange, profileImage
        //, handleDocumentsChange
        , handleSubmit, navToDoctorReport, isLoading: isEditLoading } = useEditDoctor()


    return (
        <Block isRender={!isLoading} className="create-doctor-container">
            <PersonalInfo formHandler={formHandler} profileImage={profileImage} data={data} isLoading={isLoading}
                handleProfileImageChange={handleProfileImageChange}
            />
            <SpecialitiesDocs formHandler={formHandler} data={data} isLoading={isLoading}
            // handleDocumentsChange={handleDocumentsChange}
            />
            <div className="form-actions">
                <ActionBtn title={'cancel'} onApply={navToDoctorReport} disabled={isEditLoading} />
                <ActionBtn title={isEditLoading ? 'saving...' : 'edit-doctor'} onApply={handleSubmit} disabled={isEditLoading} />
            </div>
        </Block>
    )
}

export default EditedInfo